/* ============================================================================
 * ตัวเลือกร่วมของเมนู "การตลาด"
 *
 * ข้อมูล master ของช่องทาง (ชื่อ สี ลำดับ สถานะ) อยู่ในฐานข้อมูลแล้ว ดึงผ่าน
 * GET admin/marketing-channels — ไฟล์นี้เก็บเฉพาะของที่เป็นเรื่องของหน้าตา :
 *   1) โลโก้แบรนด์ของแต่ละช่องทาง
 *   2) ชุดสี/ไอคอนให้เลือกตอนเพิ่มช่องทางใหม่
 *   3) เกณฑ์สีของแถบความคืบหน้าและอายุโพสต์
 *
 * ฟอนต์ไอคอนของโปรเจกต์เป็น fa-light ซึ่งไม่มีชุดโลโก้แบรนด์ จึงวาดโลโก้เป็น SVG
 * เอง (วิธีเดียวกับปุ่มหัวใจในหน้ารวมทรัพย์) ช่องทางที่ผู้ใช้เพิ่มเองและยังไม่มี
 * โลโก้ในชุดนี้ จะถอยไปใช้อักขระฟอนต์ไอคอนที่ตั้งไว้ใน master แทน
 * ========================================================================== */

/* โลโก้แบรนด์ — path ใน viewBox "0 0 24 24" ทั้งหมด เพื่อให้สลับไอคอนแล้วขนาดไม่เพี้ยน
   ทุกอันเป็น path เดียวจบและใช้ currentColor จะได้เปลี่ยนสีตามช่องทางได้ */
export const BRAND_MARKS = {
  facebook_group:
    "M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.69 4.53-4.69 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.96.93-1.96 1.89v2.25h3.33l-.53 3.49h-2.8V24C19.61 23.1 24 18.1 24 12.07z",
  facebook:
    "M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.69 4.53-4.69 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.96.93-1.96 1.89v2.25h3.33l-.53 3.49h-2.8V24C19.61 23.1 24 18.1 24 12.07z",
  facebook_marketplace:
    "M12 1.5 1.5 9.6v1.65h2.1V21a1.5 1.5 0 0 0 1.5 1.5h4.05v-6.15h5.7V22.5h4.05a1.5 1.5 0 0 0 1.5-1.5v-9.75h2.1V9.6L12 1.5zm0 2.79 7.35 5.67V20.1h-1.05v-6.15a1.5 1.5 0 0 0-1.5-1.5H7.2a1.5 1.5 0 0 0-1.5 1.5V20.1H4.65V9.96L12 4.29z",
  marketplace:
    "M12 1.5 1.5 9.6v1.65h2.1V21a1.5 1.5 0 0 0 1.5 1.5h4.05v-6.15h5.7V22.5h4.05a1.5 1.5 0 0 0 1.5-1.5v-9.75h2.1V9.6L12 1.5zm0 2.79 7.35 5.67V20.1h-1.05v-6.15a1.5 1.5 0 0 0-1.5-1.5H7.2a1.5 1.5 0 0 0-1.5 1.5V20.1H4.65V9.96L12 4.29z",
  line:
    "M12 2C6.2 2 1.5 5.85 1.5 10.6c0 4.25 3.73 7.81 8.76 8.49.34.07.8.22.92.51.11.26.07.66.04.93l-.15.9c-.05.26-.21 1.04.91.57 1.12-.47 6.05-3.56 8.25-6.1 1.52-1.67 2.27-3.36 2.27-5.3C22.5 5.85 17.8 2 12 2zM7.4 13.4H5.32a.55.55 0 0 1-.55-.55V8.7a.55.55 0 1 1 1.1 0v3.6H7.4a.55.55 0 1 1 0 1.1zm2.16-.55a.55.55 0 1 1-1.1 0V8.7a.55.55 0 1 1 1.1 0v4.15zm5-.0a.55.55 0 0 1-.55.55.54.54 0 0 1-.44-.22l-2.13-2.9v2.57a.55.55 0 1 1-1.1 0V8.7a.55.55 0 0 1 .99-.33l2.13 2.9V8.7a.55.55 0 1 1 1.1 0v4.15zm3.35-2.62a.55.55 0 0 1 0 1.1h-1.53v.97h1.53a.55.55 0 1 1 0 1.1h-2.08a.55.55 0 0 1-.55-.55V8.7c0-.3.25-.55.55-.55h2.08a.55.55 0 1 1 0 1.1h-1.53v.98h1.53z",
  tiktok:
    "M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.59 2.59 0 1 1 .77-5.06v-3.1a5.66 5.66 0 0 0-.77-.05A5.66 5.66 0 1 0 15.54 15.4V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.29 4.29 0 0 1-3.24-1.48z",
  instagram:
    "M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.81 3.81 0 0 1-1.38-.9 3.81 3.81 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41 1.27-.06 1.65-.07 4.85-.07M12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63c-.79.3-1.46.72-2.13 1.38A5.9 5.9 0 0 0 .63 4.14c-.3.76-.5 1.64-.56 2.91C.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.3.79.72 1.46 1.38 2.13a5.9 5.9 0 0 0 2.13 1.38c.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56a5.9 5.9 0 0 0 2.13-1.38 5.9 5.9 0 0 0 1.38-2.13c.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91a5.9 5.9 0 0 0-1.38-2.13A5.9 5.9 0 0 0 19.86.63c-.76-.3-1.64-.5-2.91-.56C15.67.01 15.26 0 12 0zm0 5.84a6.16 6.16 0 1 0 0 12.32 6.16 6.16 0 0 0 0-12.32zm0 10.16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm7.85-10.4a1.44 1.44 0 1 1-2.88 0 1.44 1.44 0 0 1 2.88 0z",
  youtube:
    "M23.5 6.19a3.02 3.02 0 0 0-2.12-2.14C19.5 3.55 12 3.55 12 3.55s-7.5 0-9.38.5A3.02 3.02 0 0 0 .5 6.19C0 8.08 0 12 0 12s0 3.92.5 5.81a3.02 3.02 0 0 0 2.12 2.14c1.88.5 9.38.5 9.38.5s7.5 0 9.38-.5a3.02 3.02 0 0 0 2.12-2.14C24 15.92 24 12 24 12s0-3.92-.5-5.81zM9.55 15.57V8.43L15.82 12l-6.27 3.57z",
  website:
    "M12 1.5a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21zm7.4 6.9h-3.06a16.3 16.3 0 0 0-1.5-4.2 8.55 8.55 0 0 1 4.56 4.2zM12 3.6c.78 1.13 1.4 2.7 1.78 4.8h-3.56C10.6 6.3 11.22 4.73 12 3.6zM3.67 13.5a8.6 8.6 0 0 1 0-3h3.5a17.9 17.9 0 0 0 0 3h-3.5zm.93 2.1h3.06c.33 1.5.83 2.92 1.5 4.2a8.55 8.55 0 0 1-4.56-4.2zm3.06-7.2H4.6a8.55 8.55 0 0 1 4.56-4.2 16.3 16.3 0 0 0-1.5 4.2zM12 20.4c-.78-1.13-1.4-2.7-1.78-4.8h3.56c-.38 2.1-1 3.67-1.78 4.8zm2.13-6.9H9.87a15.9 15.9 0 0 1 0-3h4.26a15.9 15.9 0 0 1 0 3zm.71 6.3c.67-1.28 1.17-2.7 1.5-4.2h3.06a8.55 8.55 0 0 1-4.56 4.2zm2-6.3a17.9 17.9 0 0 0 0-3h3.5a8.6 8.6 0 0 1 0 3h-3.5z",
  x: "M18.24 2.25h3.31l-7.23 8.26 8.5 11.24h-6.65l-5.22-6.82-5.96 6.82H1.68l7.73-8.83L1.25 2.25h6.82l4.71 6.23 5.46-6.23zm-1.16 17.52h1.83L7.08 4.13H5.11l11.97 15.64z",
  twitter:
    "M18.24 2.25h3.31l-7.23 8.26 8.5 11.24h-6.65l-5.22-6.82-5.96 6.82H1.68l7.73-8.83L1.25 2.25h6.82l4.71 6.23 5.46-6.23zm-1.16 17.52h1.83L7.08 4.13H5.11l11.97 15.64z",
};

/** โลโก้ของช่องทางนี้ — ไม่มีในชุด = ให้หน้าเว็บถอยไปใช้อักขระฟอนต์ไอคอนจาก master */
export const brandMark = (code) => BRAND_MARKS[code] || null;

/* ขนาดไฟล์โลโก้สูงสุดที่รับ — โลโก้เป็นรูปเล็กมาก ถ้าเกินนี้แปลว่าเลือกไฟล์ผิดใบ */
export const LOGO_MAX_SIZE = 2 * 1024 * 1024;
export const LOGO_ACCEPT = "image/png,image/jpeg,image/webp,image/svg+xml";
/* โฟลเดอร์บน storage — แยกให้ตรงกับโมดูลเหมือน assets/photo และ homepage/hero */
export const LOGO_FOLDER = "marketing/channel";

/**
 * เครื่องหมายของช่องทาง 1 ชิ้น ใช้ร่วมกันทุกที่ที่วาดชิปช่องทาง
 * (หน้าคิวงาน · โมดัลบันทึกโพสต์ · ไทม์ไลน์ประวัติ · หน้าจัดการช่องทาง)
 *
 * ไล่ลำดับ : รูปที่อัปโหลดเอง → โลโก้แบรนด์ที่ระบบวาดให้ตาม code → อักขระฟอนต์ไอคอน
 * แยกมาไว้ที่นี่เพราะถ้าต่างหน้าต่างวาดเอง โลโก้จะไม่ตรงกันเวลาเปลี่ยนกติกา
 *
 * @param {object} channel  record ช่องทางจาก API (ต้องมี logo_url / code / icon)
 * @param {string} name     ชื่อช่องทางที่แปลแล้ว ใช้เป็น alt ของรูป
 */
export const channelGlyph = (channel = {}, name = "") => {
  if (channel.logo_url) {
    return <img className="mk-logo" src={channel.logo_url} alt={name || channel.code || ""} />;
  }

  const mark = brandMark(channel.code);
  if (mark) {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d={mark} />
      </svg>
    );
  }

  return <span className="icon">{channel.icon || ""}</span>;
};

/* ชุดสีให้เลือกตอนเพิ่มช่องทางใหม่ — สีแบรนด์ที่ใช้บ่อย + สีกลางของระบบ */
export const CHANNEL_COLORS = [
  "#1877F2", // Facebook
  "#0866FF", // Marketplace
  "#06C755", // LINE
  "#111827", // TikTok
  "#E1306C", // Instagram
  "#FF0000", // YouTube
  "#4D7C0F", // แบรนด์ Munera
  "#0891B2", // ฟ้าอมเขียว
  "#7C3AED", // ม่วง
  "#EA580C", // ส้ม
];

/* ไอคอนสำรองสำหรับช่องทางที่ยังไม่มีโลโก้แบรนด์ (fa-light) */
export const CHANNEL_ICONS = [
  "", // โลก / เว็บไซต์
  "", // กลุ่มคน
  "", // ร้านค้า
  "", // แชท
  "", // วิดีโอ
  "", // กล้อง
  "", // ส่งข้อความ
  "", // อีเมล
  "", // ประกาศ
  "", // ดาว
];

/* ------------------------------------------------------------ เกณฑ์สีของหน้า */

/* อายุของโพสต์ล่าสุด — คุมสีของเวลาในคอลัมน์ "โพสต์ล่าสุด"
   ตรงกับเกณฑ์ของการ์ดสรุปด้านบน (วันนี้ / เกิน 3 วัน / เกิน 7 วัน) */
export const AGE_LEVELS = [
  { max: 0, key: "today", color: "#047857", tint: "#d1fae5" },   // โพสต์วันนี้
  { max: 2, key: "recent", color: "#4d7c0f", tint: "#eaf9d2" },  // 1-2 วัน
  { max: 6, key: "warn", color: "#b45309", tint: "#fef3c7" },    // 3-6 วัน
  { max: Infinity, key: "late", color: "#b91c1c", tint: "#fee2e2" }, // 7 วันขึ้นไป
];

/** ระดับความเก่าของโพสต์ล่าสุด — null (ยังไม่เคยโพสต์) ถือเป็นระดับแย่ที่สุด */
export const ageLevel = (days) => {
  if (days === null || days === undefined) return AGE_LEVELS[AGE_LEVELS.length - 1];
  return AGE_LEVELS.find((level) => days <= level.max) || AGE_LEVELS[AGE_LEVELS.length - 1];
};

/**
 * สีความคืบหน้า (ใช้ทั้งกับตัวเลขและแถบ) — ไล่ต่อเนื่องจากแดงเมื่อยังไม่ได้โพสต์เลย
 * ไปจนเขียวมรกตเมื่อครบทุกช่องทาง เลื่อนทีละขั้นตามจำนวนที่โพสต์ไปแล้ว
 *
 * ใช้ไล่เฉดแทนการแบ่งเป็นช่วงตายตัว เพราะจำนวนช่องทางไม่คงที่ (เพิ่ม/ลดได้จากหน้า
 * จัดการช่องทาง) แบ่งเป็นช่วงเมื่อไร ค่าที่ติดกันอย่าง 1/7 กับ 2/7 ก็จะได้สีเดียวกัน
 * จนดูไม่ออกว่าคืบหน้าขึ้น ซึ่งเป็นข้อมูลหลักที่คอลัมน์นี้ต้องบอก
 *
 * hue 0 = แดง · 145 = เขียวมรกต — ความสว่างถูกกดลงในช่วงเหลือง (hue 40-95)
 * ที่สว่างกว่าเฉดอื่นโดยธรรมชาติ ตัวเลขบนพื้นขาวจะได้อ่านออกเท่ากันทุกเฉด
 */
export const coverageColor = (posted, total) => {
  if (!total || !posted) return "hsl(0, 72%, 45%)";

  const ratio = Math.min(1, posted / total);
  const hue = Math.round(ratio * 145);

  /* ความสว่างไม่คงที่ตลอดวงล้อสี — เฉดเหลืองสว่างกว่าแดงและเขียวมาก ถ้าใช้ค่าเดียว
     ทั้งแถบ ช่วงกลาง (3/7, 4/7) จะจางจนอ่านไม่ออกบนพื้นขาว จึงกดให้เข้มลงเป็นช่วง ๆ
     ค่าที่ใช้ตรวจแล้วว่าคอนทราสต์บนพื้นขาวผ่านเกณฑ์ AA (>= 4.5:1) ทุกเฉด */
  const light = hue < 45 ? Math.round(45 - (hue / 45) * 16) : hue < 80 ? 27 : 29;

  return `hsl(${hue}, 72%, ${light}%)`;
};
